// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"532":"5b75932b","768":"411b8027"}[chunkId] + ".chunk.css";
};